<template>
  <div class="container">
    <div class="grid-container">
      <ButtonItem text="delete" color="red" @clicked="returnDbId('delete')"/>

      <RowItem
        :value="input_data.firstname"
        :isOneLine="true"
        class="row-item"
        label="First Name"
        format="text"
        id="fname"
        @input_value="setValue($event, 'firstname')"
      />
      <RowItem
        :value="input_data.lastname"
        :isOneLine="true"
        class="row-item"
        label="Last Name"
        format="text"
        id="lname"
        @input_value="setValue($event, 'lastname')"
      />
      <RowItem
        :value="input_data.email"
        :isOneLine="true"
        class="row-item"
        label="Email"
        format="text"
        id="email"
        @input_value="setValue($event, 'email')"
      />
      <RowItem
        :value="input_data.telefoonnummer"
        :isOneLine="true"
        class="row-item"
        label="Telefoonnummer"
        format="text"
        id="telefoonnummer"
        @input_value="setValue($event, 'telefoonnummer')"
      />
      <RowItem
        :value="input_data.ondernemer_email"
        :isOneLine="true"
        class="row-item"
        label="Ondernemer Email"
        format="text"
        id="ondernemer_email"
        @input_value="setValue($event, 'ondernemer_email')"
      />
      <RowItem
        :value="input_data.source_url"
        :isOneLine="true"
        class="row-item"
        label="Source Url"
        format="text"
        id="source_url"
        @input_value="setValue($event, 'source_url')"
      />
      <RowItem
        :value="input_data.opmerking"
        :isOneLine="false"
        class="row-item"
        label="Opmerking"
        format="textarea"
        id="opmerking"
        @input_value="setValue($event, 'opmerking')"
      />

      <ButtonItem text="send" @clicked="returnDbId('send')"/>

      
    </div>
  </div>
</template>



<script>
import RowItem from "./RowItem.vue";
import ButtonItem from "./ButtonItem.vue";

export default {
  name: "RowS",
  components: {
    RowItem,
    ButtonItem,
  },
  props: ["input_data"],
  created() {
    this.output_data = Object.assign({}, this.input_data);
  },
  data: () => {
    return {
      firstname: "",
      lastname: "",
      email: "",
      telefoonnummer: "",
      opmerking: "",
      ondernemer_email: "",
      source_url: "",
      db_id: '',
    };
  },
  methods: {
    setValue(value, item_name) {
      this.output_data[item_name] = value;
      this.$emit('valuesChanged', this.output_data);
    },
    returnDbId(action) {
      if(action=='delete') {
        this.$emit('deleteRow', this.input_data.db_id)
      } else if (action == 'send') {
        this.$emit('sendRow', this.input_data.db_id)
      }
      
    }
  },
};
</script>

<style scoped>
.container {
  overflow: auto;
  background-color: rgba(79,147,182,1);
  border-radius: 28px;
  margin-top: 1%;
}

.grid-container {
  display: grid;
  grid-template-columns: auto auto auto auto auto auto auto auto auto auto;
  padding: 2%;
}

.row-item {
  margin-right: 5%;
}
</style>
